import { render, staticRenderFns } from "./UploadTtyClmPaymRes.vue?vue&type=template&id=60114b2d&"
import script from "./UploadTtyClmPaymRes.vue?vue&type=script&lang=js&"
export * from "./UploadTtyClmPaymRes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports